import { InjectionToken } from '@angular/core';
import { IHotjarSettings } from './i-hotjar-settings';

export const HOTJAR_SETTINGS_TOKEN = new InjectionToken<IHotjarSettings>('hotjar-settings', {
  factory: () => ({ trackingCode: '', version: 6 })
});